<template>
  <div class="call-fb-container">
    <div class="call-fb-header">
      <CallFbHeader
        v-model:caller-id="selectedCallerId"
        v-model:start-date="selectedStartDate"
        v-model:end-date="selectedEndDate"
        v-model:default-call-result-type-id="selectedDefaultCallResultTypeId"
        v-model:custom-call-result-type-id="selectedCustomCallResultTypeId"
        v-model:call-connection-point="selectedCallConnectionPoint"
      />
    </div>
    <div class="call-fb-main-content">
      <div class="call-fb-main-content-left">
        <CallFbCharts
          :caller-id="selectedCallerId"
          :start-date="selectedStartDate"
          :end-date="selectedEndDate"
          :default-call-result-type-id="selectedDefaultCallResultTypeId"
          :custom-call-result-type-id="selectedCustomCallResultTypeId"
          :call-connection-point="selectedCallConnectionPoint"
        />
      </div>
      <div class="call-fb-main-content-right">
        <CallFbCards
          :caller-id="selectedCallerId"
          :start-date="selectedStartDate"
          :end-date="selectedEndDate"
          :default-call-result-type-id="selectedDefaultCallResultTypeId"
          :custom-call-result-type-id="selectedCustomCallResultTypeId"
          :call-connection-point="selectedCallConnectionPoint"
          :call-result-id="selectedCallResultId"
        />
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { defineModel } from 'vue';
import CallFbCards from './CallFbCards.vue';
import CallFbCharts from './CallFbCharts.vue';
import CallFbHeader from './CallFbHeader.vue';

const selectedCallerId = defineModel<number | undefined>('callerId');
const selectedStartDate = defineModel<string | undefined>('startDate');
const selectedEndDate = defineModel<string | undefined>('endDate');
const selectedDefaultCallResultTypeId = defineModel<number | null>('defaultCallResultTypeId', { default: null });
const selectedCustomCallResultTypeId = defineModel<number | null>('customCallResultTypeId', { default: null });
const selectedCallConnectionPoint = defineModel<string | null>('callConnectionPoint', { default: null });
const selectedCallResultId = defineModel<number | null>('callResultId', { default: null });
</script>

<style lang="scss" scoped>
.call-fb-container {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.call-fb-main-content {
  display: flex;
  flex-direction: row;
  width: 100%;
  flex: 1;
  min-height: 0;
}

.call-fb-main-content-left {
  width: 280px;
  height: 100%;
  overflow-y: auto;
  flex-shrink: 0;
  border-right: 1px solid $bdcolor-base;
}

.call-fb-main-content-right {
  height: 100%;
  overflow-y: auto;
  flex-grow: 1;
}
</style>
